
<template>
  <!--活动订单-->
  <div class="activity-order">
    <div class="base-info">
      <div class="ant-card-head">
        <div class="ant-card-head-wrapper">
          <div class="ant-card-head-title">基础信息</div>
        </div>
      </div>

      <a-form class="base-info-form">
        <a-row>
          <a-col :span="8">
            <a-form-item label="活动名称">
              <span class="text" style="">{{ orderData.activityTitle }}</span>
            </a-form-item>
          </a-col>
          <a-col :span="8">
            <a-form-item label="活动时间">
              <span class="text">{{ orderData.time }}</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      class="order-table"
      ref="table"
      rowKey="id"
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"
      :addHandleParam="addHandleParam"
      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_userName" slot-scope="{row}">
        <a-button @click="toUserDetail(row)" type="link">{{row.userName}}</a-button>
      </template>
      <template slot="opt_orderId" slot-scope="{row}">
        <a-button @click="toOrderManage(row)" type="link">{{row.orderId}}</a-button>
      </template>

      <template slot="opt_status" slot-scope="{row}">
        <span>{{ row.status === 1 ? '已领取' : '未领取' }}</span>
      </template>
    </x-tabula>
  </div>
</template>

<script>
export default {
  name: 'activityOrder',
  data () {
    return {
      orderData: {},
      searchList: [
        { props: ['keywords'], placeholder: '手机号/订单号', options: [], inputType: 'input' }
      ],
      tableOptList: [
        { text: '导出数据', icon: 'download', handle: this.exportData, permi: ['community:activityOrder:export'] }
      ],
      rowOptList: [],
      columns: [
        { title: '奖品', dataIndex: 'prizeName', align: '', width: '' },
        { title: '中奖用户', dataIndex: 'userName', align: '', width: '', scopedSlots: { customRender: 'userName' } },
        { title: '状态', dataIndex: 'status', align: '', width: '', scopedSlots: { customRender: 'status' } },
        { title: '中奖时间', dataIndex: 'lotteryTime', align: '', width: '' },
        { title: '领取时间', dataIndex: 'receiveTime', align: '', width: '' },
        { title: '订单号', dataIndex: 'orderId', align: '', width: '', scopedSlots: { customRender: 'orderId' } }
      ],
      dataSource: [],
      searchParams: {
        keywords: undefined
      },
      listApi: {
        url: `/pm/lottery/orderList/${this.$route.query.id}`,
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      addHandleParam: {
        route: '',
        addTitle: '',
        editTitle: ''
      },
      deleteParam: {
        url: '',
        title: '',
        key: '',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  created () {
    const query = this.$route.query;
    if (Object.keys(query).length) {
      this.orderData = query;
    }
    this.getSelect();
  },
  methods: {
    getSelect () {
    },
    /** 跳转用户详情 */
    toUserDetail (row) {
      this.$router.push({
        name: 'memberDetail',
        query: { id: row.userId, ...this.breadParam(this) }
      });
    },
    /** 进入订单管理 */
    toOrderManage (row) {
      this.$router.push({
        name: 'order-1',
        query: { id: row.orderId }
      });
    },
    /** 导出数据 */
    exportData () {
      this.$post({
        url: `/pm/lottery/export/${this.orderData.id}`,
        params: {},
        config: { responseType: 'blob' }
      }).catch(res => {
        this.downLoadStream(res);
      });
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss">
.activity-order {
  .base-info {
    margin-bottom: 24px;
    background-color: #fff;
    .base-info-form {
      padding: 24px;
      .text {
        margin-left: 10px;
        color: #00000072;
      }
    }
  }
  .order-table {
    background-color: #fff;
    padding: 24px;
  }
}
</style>
